"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var metrics_engine_1 = require("@tableau/metrics-engine");
exports.getInitialValue = function (metricValues) {
    if (metricValues && metricValues.length) {
        return metricValues[metricValues.length - 1];
    }
    else {
        return undefined;
    }
};
exports.getColorForPoint = function (value) {
    var delta = value ? metrics_engine_1.computeMetricComparison(value) : undefined;
    if (delta === undefined) {
        // don't render the comparison pill if there is no comparison value
        return undefined;
    }
    var colorAccessor = metrics_engine_1.buildColorAccessor(metrics_engine_1.testEffectiveDefinition);
    return value ? colorAccessor(value) : undefined;
};
//# sourceMappingURL=engine.js.map